// import site route
import {siteRoutes} from './routes/SiteRoutes'

export let routes = [
    ...siteRoutes,
]

